function LoadingIcon() {
  return <p>Loading...</p>
}

export default LoadingIcon;
